var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isShow)?_c('div',{staticClass:"image-modal-mask"},[_c('div',{staticClass:"images"},[_c('img',{attrs:{"src":_vm.imageUrl[_vm.index],"alt":""}}),_c('a-icon',{staticClass:"close",attrs:{"type":"close-circle"},on:{"click":() => (_vm.isShow = false)}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }